import { SxProps, Theme } from '@mui/material';
import { minHeightDvh } from '../../theme/mixins';

/**
 * The wait while the session is being resolved.
 *
 * Sized to the space between header and footer rather than to the viewport. It used to ask
 * for a full `100vh` while sitting *inside* `Layout`, which is itself a `100vh` column --
 * so the loading state was about two screens tall and the spinner it was centring sat
 * below the fold, which is a strange thing for a progress indicator to do.
 *
 * The 200px matches the auth forms' own `calc(100vh - 200px)`: header, footer and the
 * container's vertical padding.
 */
export const loadingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ...minHeightDvh('calc(100dvh - 200px)'),
    gap: 2,
};
